import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StateService {
  read<T>(name: string): T | null {
    const params = localStorage.getItem(name);
    if (!params || params.length === 0) {
      return null;
    }

    return JSON.parse(params);
  }

  store<T>(name: string, state: T): void {
    const paramsJSON = JSON.stringify(state);
    localStorage.setItem(name, paramsJSON);
  }
}
